// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"22":"b6809e8a3eaa526f4ff4","671":"020bfca7ce627b378101"}[chunkId] + ".css";
};